import requests from "./api/api";

const ProfileCargoService = {

   
    getMyProfile:(body)=>requests.get('/user/v1/get-my-profile',body),
    updateProfile:(body)=>requests.put('/user/v1/update-full',body),
   
};

export default ProfileCargoService;